module.exports = __webpack_public_path__ + "static/img/Logo8_TrailsOfIndochina.540e0c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Logo8_TrailsOfIndochina.png
// module id = 245
// module chunks = 1